import { Icon, IconProps } from '@material-ui/core';
import React from 'react';

type Props = IconProps & { revert?: boolean };

export const DropDownIcon = ({ revert, ...props }: Props) => (
    <Icon {...props}>{revert ? 'arrow_drop_up' : 'arrow_drop_down'}</Icon>
);
